import React from 'react'

function ModalInicio({ isOpen, closeModal, content }) {
    if (!isOpen) {
        return null;
      }
    
      return (
        <div className="modal modal-inicio">
          <div className="modal-content modal-content-inicio">
            {content}
            <button onClick={closeModal}>Cerrar Modal</button>
          </div>
        </div>
      );
}

export default ModalInicio